// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nhIj","top":"styles_top__2c9wt","left":"styles_left__ZMfMR","description":"styles_description__3nvNT"};